/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseHeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/base-hero-banner.fragment';
import {ActionLinksFragment} from '@amblique/contentful/app/contentful/fragments/action-links/action-links.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {RichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/rich-text-block.fragment';
import {VideoFragment} from '@amblique/contentful/app/contentful/fragments/video/video.fragment';

export const FullHeroBannerFragment = gql`
  ${ActionLinksFragment}
  ${BaseHeroBannerFragment}
  ${ImageFragment}
  ${RichTextBlockFragment}
  ${VideoFragment}

  fragment FullHeroBannerFragment on HeroBanner {
    ...BaseHeroBannerFragment

    body {
      ...RichTextBlockFragment
    }
    cta {
      ...ActionLinksFragment
    }
    rightCta {
      ...ActionLinksFragment
    }
    backgroundMedia {
      ... on Image {
        ...ImageFragment
      }
      ... on Video {
        ...VideoFragment
      }
    }
  }
`;
